<script setup lang="ts">
import { computed } from 'vue';
import { formatDeliveryDateWithFallback } from '@/shared/helpers';
import { useProductPage } from '@/features/product-page/business/use-product-page';
import { IconDelivery } from '@/features/ui-kit/icons';

const { state } = useProductPage();
const product = computed(() => state.product);
</script>

<template>
  <div class="cta-delivery">
    <div class="cta-delivery--title">Доставка</div>
    <div class="cta-delivery--content">
      <div class="icon-wrapper">
        <IconDelivery :size="40" color="primary" class="icon" />
      </div>
      <div class="label" data-test-id="text__info-motivation">
        <span class="label--date">
          Доставим
          <span class="label--date--time">{{
            formatDeliveryDateWithFallback(product?.cardNearestDeliveryInfo?.nearestDelivery)
          }}</span>
        </span>
        <span class="label--method"> в пункт выдачи или курьером </span>
        <!-- <span class="label--place">Товар на складе продавца</span> -->
      </div>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
.cta-delivery
  &--title
    font-size 20px
    font-weight 700
    line-height 24px
    margin-bottom 12px
    +Media(Mobile, Tablet)
      font-weight 600
  &--content
    display flex
    align-items center
    column-gap 12px
    font-family 'Inter'
    .icon-wrapper
      padding 0
      width 40px
      height 40px
      border-radius 8px
      background #D6F4FF
      display flex
      align-items center
      justify-content center
      .icon
        color #000000
    .label
      display flex
      flex-direction column
      font-weight 400
      font-size 14px
      line-height 18px
      letter-spacing -0.01em
      color Gray(DK40)
      &--date
        &--time
          font-weight 600
      &--method
        font-weight 400
        font-size 14px
        line-height 18px
      &--place
        color var(--color-text-tertiary)
        font-size 12px
        font-weight 400
        line-height 16px
        margin-top 4px
</style>
